module.exports = __webpack_public_path__ + "icon_1.cbeea8bb.png";